// context/AuthContext.js
import React, { createContext, useState, useEffect, useContext } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Check localStorage for a token on initial load
  useEffect(() => {
    console.log("Checking localStorage for token...");
    const token = localStorage.getItem("authToken");
    if (token) {
      console.log("Token found, setting isAuthenticated to true");
      setIsAuthenticated(true);
    } else {
      console.log("No token found, user is not authenticated");
    }
  }, []);

  const login = (token) => {
    console.log("Logging in, saving token to localStorage");
    localStorage.setItem("authToken", token); // Save token to localStorage
    setIsAuthenticated(true);
  };

  const logout = () => {
    console.log("Logging out, removing token from localStorage");
    localStorage.removeItem("authToken"); // Remove token from localStorage
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
